import Button from 'tio-reimagined/components/button';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import { Header, HStack, Section, VStack } from 'tio-reimagined/components/layout';
import { PhCheck } from 'ember-phosphor-icons';

<template>
  <TioPageBreadcrumbs class="mb-4" as |b|>
    <b.crumb @route="authenticated.syf.dashboard" @label="Dashboard" />
    <b.crumb @route="authenticated.syf.insights.idr" @label="IDR" />
  </TioPageBreadcrumbs>
  <Header>{{t "syf.insights.idr.heading"}}</Header>
  <Section>
    <:body>
      <HStack>
        <VStack class="w-full md:w-1/2">
          <h2 class="text-lg font-semibold">{{t "syf.insights.idr.explore.heading"}}</h2>
          <p>{{t "syf.insights.idr.explore.one"}}</p>
          <p>{{t "syf.insights.idr.explore.two"}}</p>
        </VStack>
        <VStack class="w-full md:w-1/2">
          <h2 class="text-lg font-semibold">{{t "syf.insights.idr.advantage.heading"}}</h2>
          <div class="tio-row-top-tight">
            <PhCheck @size="24" class="tio-fg-success" />
            <p>{{t "syf.insights.idr.advantage.one"}}</p>
          </div>
          <div class="tio-row-top-tight">
            <PhCheck @size="24" class="tio-fg-success" />
            <p>{{t "syf.insights.idr.advantage.two"}}</p>
          </div>
          <div class="tio-row-top-tight text-base leading-6">
            <PhCheck @size="16" class="tio-fg-success flex-none" />
            <p>{{t "syf.insights.idr.advantage.three"}}</p>
          </div>
          <hr />
          <div>{{t "syf.insights.idr.advantage.label"}}</div>
          <Button
            @intent="primary"
            @appearance="outlined"
            {{on "click" (transitionTo "authenticated.idr")}}
          >
            {{t "syf.insights.idr.advantage.button"}}
          </Button>
        </VStack>
      </HStack>
    </:body>
  </Section>
</template>
